import React from 'react';

export const daysUntil = (dateStr: string | null | undefined): number | null => {
  if (!dateStr) return null;
  const diff = new Date(dateStr).getTime() - Date.now();
  return Math.floor(diff / (24 * 60 * 60 * 1000));
};

export const suiteFromType = (raw?: string | null): 'landlord' | 'wholesale' | 'other' => {
  const v = String(raw || '').toLowerCase();
  if (v.includes('landlord') || v.includes('property') || v.includes('letting')) return 'landlord';
  if (!v || v.includes('wholesale') || v.includes('retail') || v.includes('shop') || v.includes('trade')) return 'wholesale';
  return 'other';
};

export const statusStyle = (status: string): React.CSSProperties => {
  const map: Record<string, { bg: string; color: string }> = {
    trial: { bg: '#dbeafe', color: '#1d4ed8' },
    pending: { bg: '#fef3c7', color: '#b45309' },
    rejected: { bg: '#fee2e2', color: '#991b1b' },
    active: { bg: '#dcfce7', color: '#166534' },
    expired: { bg: '#fee2e2', color: '#b91c1c' },
    cancelled: { bg: '#f3f4f6', color: '#4b5563' },
    canceled: { bg: '#f3f4f6', color: '#4b5563' },
    past_due: { bg: '#fef3c7', color: '#b45309' },
    unpaid: { bg: '#fee2e2', color: '#b91c1c' },
    payment_sent: { bg: '#ede9fe', color: '#6d28d9' },
    paid: { bg: '#d1fae5', color: '#047857' },
  };
  const c = map[status] || map.cancelled;
  return {
    background: c.bg,
    color: c.color,
    borderRadius: 999,
    padding: '3px 10px',
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'capitalize',
  };
};

export const fmtDate = (d?: string | null) =>
  d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
